import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { Spinner, EmptyState } from "../components/common";
import api from "../lib/api";
import { fmtDate } from "../lib/format";

export default function Notifications() {
  const navigate = useNavigate();
  const [ntfs, setNtfs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/notifications").then((r) => setNtfs(r.data.notifications)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read"); load(); };

  if (loading) return <Spinner />;

  return (
    <div className="max-w-2xl space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="font-heading font-extrabold text-2xl text-navy">Notifications</h1>
        {ntfs.some((n) => !n.read) && <button onClick={markAll} data-testid="mark-all-read" className="text-sm font-semibold text-sky flex items-center gap-1"><CheckCheck size={15} /> Mark all read</button>}
      </div>
      {ntfs.length === 0 ? (
        <EmptyState icon={Bell} title="Belum ada notifikasi" subtitle="Update pesanan & trip akan muncul di sini." />
      ) : (
        <div className="space-y-2">
          {ntfs.map((n) => (
            <button key={n.id} onClick={() => n.link && navigate(n.link)} data-testid={`notif-${n.id}`}
              className={`w-full flex items-start gap-3 rounded-2xl p-4 text-left border transition-colors ${n.read ? "bg-white border-black/5" : "bg-lime-light/30 border-lime/40"}`}>
              <div className="w-9 h-9 rounded-full bg-navy text-white flex items-center justify-center shrink-0"><Bell size={16} /></div>
              <div className="flex-1">
                <div className="font-semibold text-navy text-sm">{n.title}</div>
                {n.body && <div className="text-sm text-muted-foreground">{n.body}</div>}
                <div className="text-[11px] text-muted-foreground mt-0.5">{fmtDate(n.created_at)}</div>
              </div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-lime mt-2" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
